import { render, staticRenderFns } from "./NavigationDrawerDesktop.vue?vue&type=template&id=19658742"
import script from "./NavigationDrawerDesktop.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerDesktop.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerDesktop.vue?vue&type=style&index=0&id=19658742&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports